e360.controller('EventNotesController',
   ['$scope', 'eventNotesApi', 'dialogs', 'utils', 'session', 'toast',
      function ($scope, eventNotesApi, dialogs, utils, session, toast) {
         var members = {};

         members.initialize = function () {
            $scope.newNote = '';

            $scope.$watch('$ctrl.model.selected.id', function(eventId) {
               members.service = eventNotesApi(eventId);
               members.getNotes();
            });
         };

         members.getNotes = function () {
            $scope.isBusy = true;
            members.service.list().then(function (notes) {
               $scope.notes = notes;
            })['finally'](function () {
               $scope.isBusy = false;
            });
         };

         $scope.getPostedText = function (note) {
            var text = (Date.parse(note.modified) > Date.parse(note.created)) ? 'Modified' : 'Posted';
            text += ' on ' + utils.formatDate(note.modified, 'YYYY/MM/DD hh:mma');
            if (note.user) {
               text += ' by ' + note.user;
            }
            return text;
         };

         $scope.canEdit = function (note) {
            return note.userId === session.getUser().id;
         };

         $scope.canRemove = function (note) {
            return $scope.canEdit(note) || session.isSuperAdmin();
         };

         $scope.remove = function (note) {
            dialogs.confirm('Are you sure you want to remove this note?').then(function () {
               members.service.del(note.id).then(function () {
                  toast.success()
                     .message('Note removed!')
                     .send();
                  members.getNotes();
               });
            });
         };

         $scope.isEditing = function () {
            return _.any($scope.notes, function (note) {
               return note.isEditing;
            });
         };

         $scope.save = function (note) {
            var promise, isEdit = (note) ? true : false;

            if (isEdit) {
               promise = members.service.update(note);
            } else if ($scope.newNote.length > 0) {
               promise = members.service.create({
                  note: $scope.newNote
               });
            }

            $scope.isBusy = true;
            promise.then(function () {
               toast.success()
                  .message('Note saved!')
                  .send();
               if (!isEdit) {
                  $scope.newNote = '';
               }
            })['finally'](function () {
               members.getNotes();
            });
         };

         members.initialize();
      }]);
